export const OrderDayDiet = (json: IOrderDietDay): IOrderDietDayModel => {
	const fromJSON = (itemJson: IOrderDietDay) => {
		const { diet_type, name, ...rest } = itemJson
		return {
			dietType: diet_type,
			name: name ? LangContentToModel(name) : { pl: '' },
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const OrderDayMealSlot = (json: IOrderDayMealSlot): IOrderDayMealSlotModel => {
	const fromJSON = (itemJson: IOrderDayMealSlot) => {
		const { diet_type, variant_id, is_extra_meal, is_selected, meal_kind, meal_type, size_id, ...rest } = itemJson
		return {
			dietType: diet_type,
			variantID: variant_id,
			isExtraMeal: is_extra_meal,
			isSelected: is_selected,
			mealKind: meal_kind,
			mealType: meal_type,
			sizeID: size_id,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const AddonDay = (json: IDietAddonDay): IDietAddonDayModel => {
	const { addon_id, paid_points, paid_price, addon, ...rest } = json

	return {
		addonID: addon_id,
		paidPoints: paid_points,
		paidPrice: paid_price,
		addon: addon ? Addon(addon) : null,
		...rest,
	}
}

export const OrderDay = (json: IOrderDay): IOrderDayModel => {
	const fromJSON = (itemJson: IOrderDay) => {
		const {
			address,
			address_id,
			cart_diet_day_id,
			all_meals_selected,
			client_diet,
			date,
			diet_id,
			diet,
			meal_slots,
			diet_label,
			diet_type,
			addons,
			...rest
		} = itemJson
		return {
			address: address ? ClientAddress(address) : null,
			addressID: address_id,
			cartDietDayID: cart_diet_day_id,
			allMealsSelected: all_meals_selected,
			clientDiet: client_diet ? Order(client_diet) : null,
			date: date ? new Date(date) : null,
			dietID: diet_id,
			diet: diet ? OrderDayDiet(diet) : null,
			mealSlots: meal_slots ? meal_slots.map(OrderDayMealSlot) : [],
			dietLabel: diet_label,
			dietType: diet_type,
			addons: addons ? addons.map(AddonDay) : null,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const orderDayToJSON = (obj: Partial<IOrderDayModel>): Partial<IOrderDay> => {
	const { ...rest } = obj
	return {
		...rest,
	}
}

export const OrderDayChange = (json: IOrderDayChange): IOrderDayChangeModel => {
	const fromJSON = (itemJson: IOrderDayChange) => {
		const {
			client_diet_days,
			new_points_per_day,
			new_price_per_day,
			points_refund,
			points_to_pay,
			price_to_pay,
			...rest
		} = itemJson
		return {
			clientDietDays: client_diet_days,
			newPointsPerDay: new_points_per_day,
			newPricePerDay: new_price_per_day,
			pointsRefund: points_refund,
			pointsToPay: points_to_pay,
			priceToPay: price_to_pay,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const orderDayChangeToJSON = (obj: Partial<IOrderDayChangeModel>): Partial<IOrderDayChange> => {
	const { clientDietDays, newPointsPerDay, newPricePerDay, pointsRefund, pointsToPay, priceToPay, ...rest } = obj
	return {
		client_diet_days: clientDietDays,
		new_points_per_day: newPointsPerDay,
		new_price_per_day: newPricePerDay,
		points_refund: pointsRefund,
		points_to_pay: pointsToPay,
		price_to_pay: priceToPay,
		...rest,
	}
}
